import React from 'react';
import { useAlert } from '../Context/AlertContext';

const GlobalAlert = () => {
  const { alert } = useAlert();


  if (!alert.message) return null; // Don't render anything if there's no message

  return (
    <div
      className={`alert alert-${alert.type} position-fixed top-0 end-0 m-3`}
      style={{ zIndex: 1050 }}
    >
      {alert.message}
    </div>
  );
};

export default GlobalAlert;
